import React from "react";
import "./course.transcript.cmp.scss";

interface TranscriptWord {
  start_time: number;
  end_time: number;
  punct: string;
}

interface CourseTranscriptProps {
  transcripts: TranscriptWord[];
  currentTime: number | null;
  loading: boolean;
  onWordClick: (e: any, time: number) => void;
  className?: string;
}

const CourseTranscriptCmp = ({
  transcripts,
  currentTime,
  loading,
  onWordClick,
  className = "",
}: CourseTranscriptProps) => {
  if (loading) {
    return (
      <div className={`transcript ${className}`}>
        <div className="transcript__body">
          <div className="loader loader-center"></div>
        </div>
      </div>
    );
  }

  if (!transcripts || transcripts.length === 0) {
    return (
      <div className={`transcript ${className}`}>
        <div className="transcript__body">
          <div>No transcripts available</div>
        </div>
      </div>
    );
  }

  return (
    <div className={`transcript ${className}`}>
      <div className="transcript__body">
        {transcripts.map((word, index) => (
          <span
            key={index}
            className={
              word.start_time < currentTime &&
              word.end_time > currentTime
                ? "selected-word"
                : ""
            }
            onDoubleClick={(e) => onWordClick(e, word.start_time)}
            onTouchStart={(e) => onWordClick(e, word.start_time)}
          >
            <span>{word.punct}</span>{" "}
          </span>
        ))}
      </div>
    </div>
  );
};

export default CourseTranscriptCmp;